// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'components/Editable/Editable'
import Image from 'components/Image/Image'
import ImageGallery from 'components/ImageGallery/ImageGallery'
import MediaPlayer from 'components/MediaPlayer/MediaPlayer'
import { get, loop } from 'utilities/objects'

class Columns extends React.Component {
	renderHtml = ( key, content ) => {
		const { contentId, sectionId, data } = this.props

		return (
			<div className="-text">
				<Editable
					element="div"
					id={ contentId }
					sectionId={ sectionId }
					sectionType={ data.type }
					sectionDataId={ `${key}_html` }
					content={ content }
					contentType="html"
				/>
			</div>
		)
	}

	renderMedia = ( key, content ) => {
		const { contentId, sectionId, data } = this.props

		const mediaData = content || {
			url: '',
			alt: '',
			aspect_ratio: '',
			focal_point: '',
			copy_space: '',
			width: '',
			height: '',
			thumb: '',
			srcset: '',
			type: '',

			// Video:
			id: '',
			service: '',
			thumb_url: ''
		}
		let isVideo = false

		if ( 'video' == mediaData.type || 'external_video' == mediaData.type ) {
			isVideo = true
		}

		return (
			<div className="-media-wrap">
				<div className="-media">
					<div className="editor-image-placeholder"></div>

					<Editable
						id={ contentId }
						sectionId={ sectionId }
						sectionType={ data.type }
						sectionDataId={ `${key}_image/video` }
						contentType="image/video"
						className="-media-inner"
						imageId={ mediaData.id }
					>
						{ isVideo &&
							<div className="-video">
								<MediaPlayer
									key={ mediaData.id }
									id={ mediaData.id }
									service={ mediaData.service }
									url={ mediaData.url }
									thumb_url={ mediaData.thumb_url }
									width={ mediaData.width }
									height={ mediaData.height }
									aspectRatio={ mediaData.aspect_ratio }
								/>
							</div>
						||
							<Image
								thumb={ mediaData.thumb }
								url={ mediaData.url }
								srcset={ mediaData.srcset }
								srcsetWebp={ mediaData.srcset_webp }
								sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
								alt={ mediaData.alt }
								focalPoint={ mediaData.focal_point }
								width={ mediaData.width }
								height={ mediaData.height }
								aspectRatio={ mediaData.aspect_ratio }
								borderRadius={ mediaData.border_radius }
								boxShadow={ mediaData.box_shadow }
							/>
						}
					</Editable>
				</div>
			</div>
		)
	}

	renderImageGallery = ( key, content ) => {
		const { contentId, sectionId, data } = this.props

		return (
			<div className="-media-wrap">
				<div className="-media">
					<div className="editor-image-placeholder"></div>

					<Editable
						id={ contentId }
						sectionId={ sectionId }
						sectionType={ data.type }
						sectionDataId={ `${key}_image_gallery` }
						contentType="image_gallery"
						className="-media-inner"
						imageGalleryIds={ content.ids }
						imageGalleryColumns={ content.columns }
						imageGalleryInnerSpacing={ content.inner_spacing }
						imageGalleryBorderRadius={ content.border_radius }
					>
						<ImageGallery
							items={ content.items }
							columns={ content.columns }
							innerSpacing={ content.inner_spacing }
							borderRadius={ content.border_radius }
							boxShadow={ content.box_shadow }
						/>
					</Editable>
				</div>
			</div>
		)
	}

	render() {
		const { contentId, sectionId, data } = this.props
		const sectionHtmlId = `columns-${sectionId}`

		const columns = get( ['settings', 'columns'] )( data, {} )
		const columnsNumber = Object.keys( columns ).length
		const columnsNumberMobile = get( ['settings', 'columns_number_mobile'] )( data, false )
		const textLight = get( ['settings', 'text_light'] )( data, false )
		const classCustom = get( ['settings', 'class'] )( data, false )
		let className = `section-columns`
		let customStyles = ''

		if ( columnsNumberMobile ) {
			className += ` -columns-number-mobile-${columnsNumberMobile}`
		}

		if ( textLight ) {
			className += ' with-light-text'
		}

		if ( classCustom ) {
			className += ` ${classCustom}`
		}

		// Offset top:
		const offsetTop = get( ['settings', 'offset_top'] )( data, false )
		const offsetTopCustom = get( ['settings', 'offset_top_custom'] )( data, false )

		const offsetTopDesktop = get( ['settings', 'desktop_offset_top'] )( data, false )
		const offsetTopCustomDesktop = get( ['settings', 'desktop_offset_top_custom'] )( data, false )

		const offsetTopTablet = get( ['settings', 'tablet_offset_top'] )( data, false )
		const offsetTopCustomTablet = get( ['settings', 'tablet_offset_top_custom'] )( data, false )

		const offsetTopMobile = get( ['settings', 'mobile_offset_top'] )( data, false )
		const offsetTopCustomMobile = get( ['settings', 'mobile_offset_top_custom'] )( data, false )

		if ( offsetTop ) {
			className += ` -offset-top-${offsetTop}`
		}
		if ( offsetTopCustom ) {
			customStyles += `#${sectionHtmlId} {margin-top: ${offsetTopCustom}px}`
		}

		if ( offsetTopDesktop ) {
			className += ` -desktop-offset-top-${offsetTopDesktop}`
		}
		if ( offsetTopCustomDesktop ) {
			customStyles += `.breakpoint-large-min #${sectionHtmlId} {margin-top: ${offsetTopCustomDesktop}px}`
		}

		if ( offsetTopTablet ) {
			className += ` -tablet-offset-top-${offsetTopTablet}`
		}
		if ( offsetTopCustomTablet ) {
			customStyles += `.breakpoint-medium #${sectionHtmlId} {margin-top: ${offsetTopCustomTablet}px}`
		}

		if ( offsetTopMobile ) {
			className += ` -mobile-offset-top-${offsetTopMobile}`
		}
		if ( offsetTopCustomMobile ) {
			customStyles += `.breakpoint-small #${sectionHtmlId} {margin-top: ${offsetTopCustomMobile}px}`
		}

		return (
			<div id={ sectionHtmlId } className={ className }>
				<div className="-inner">
					{ loop( columns, ( key, item ) => {
						let columnHtmlId = `${sectionHtmlId}_${key}`
						let style = {
							gridColumn: `${item.start} / ${item.end}`
						}
						let innerMarkup = null
						let contentKey = `${key}_${item.column_type}`
						let content = data[ contentKey ] || ''

						if ( 'html' == item.column_type ) {
							innerMarkup = this.renderHtml( key, content )
						} else if ( 'image/video' == item.column_type ) {
							innerMarkup = this.renderMedia( key, content )
						} else if ( 'image_gallery' == item.column_type ) {
							innerMarkup = this.renderImageGallery( key, content )
						}

						let className = '-item'
						className += ` has-${columnsNumber}-columns`

						if ( item.sticky ) {
							className += ' is-sticky'
						}

						if ( item.v_align ) {
							className += ` -v-align-${item.v_align}`
						} else {
							className += ` -v-align-start`
						}

						if ( item.text_align ) {
							className += ` -text-align-${item.text_align}`
						}

						if ( item.class ) {
							className += ` ${item.class}`
						}

						let tooltipMarkup = ''

						if ( item.tooltip ) {
							className += ` with-tooltip`
							tooltipMarkup = (
								<div className="-tooltip">
									<div className="-tooltip-inner">
										{ item.tooltip }
									</div>
								</div>
							)
						}

						// Padding top:
						if ( item.padding_top ) {
							className += ` -padding-top-${item.padding_top}`
						}
						if ( item.desktop_padding_top ) {
							className += ` -desktop-padding-top-${item.desktop_padding_top}`
						}
						if ( item.desktop_padding_top_custom ) {
							customStyles += `.breakpoint-large-min #${sectionHtmlId} {padding-top: ${item.desktop_padding_top_custom}px}`
						}
						if ( item.tablet_padding_top ) {
							className += ` -tablet-padding-top-${item.tablet_padding_top}`
						}
						if ( item.tablet_padding_top_custom ) {
							customStyles += `.breakpoint-medium #${sectionHtmlId} {padding-top: ${item.tablet_padding_top_custom}px}`
						}
						if ( item.mobile_padding_top ) {
							className += ` -mobile-padding-top-${item.mobile_padding_top}`
						}
						if ( item.mobile_padding_top_custom ) {
							customStyles += `.breakpoint-small #${sectionHtmlId} {padding-top: ${item.mobile_padding_top_custom}px}`
						}

						// Padding bottom:
						if ( item.padding_bottom ) {
							className += ` -padding-bottom-${item.padding_bottom}`
						}
						if ( item.desktop_padding_bottom ) {
							className += ` -desktop-padding-bottom-${item.desktop_padding_bottom}`
						}
						if ( item.desktop_padding_bottom_custom ) {
							customStyles += `.breakpoint-large-min #${sectionHtmlId} {padding-bottom: ${item.desktop_padding_bottom_custom}px}`
						}
						if ( item.tablet_padding_bottom ) {
							className += ` -tablet-padding-bottom-${item.tablet_padding_bottom}`
						}
						if ( item.tablet_padding_bottom_custom ) {
							customStyles += `.breakpoint-medium #${sectionHtmlId} {padding-bottom: ${item.tablet_padding_bottom_custom}px}`
						}
						if ( item.mobile_padding_bottom ) {
							className += ` -mobile-padding-bottom-${item.mobile_padding_bottom}`
						}
						if ( item.mobile_padding_bottom_custom ) {
							customStyles += `.breakpoint-small #${sectionHtmlId} {padding-bottom: ${item.mobile_padding_bottom_custom}px}`
						}

						// Offset top:
						if ( item.offset_top ) {
							className += ` -offset-top-${item.offset_top}`
						}
						if ( item.desktop_offset_top ) {
							className += ` -desktop-offset-top-${item.desktop_offset_top}`
						}
						if ( item.desktop_offset_top_custom ) {
							customStyles += `.breakpoint-large-min #${sectionHtmlId} {margin-top: ${item.desktop_offset_top_custom}px}`
						}
						if ( item.tablet_offset_top ) {
							className += ` -tablet-offset-top-${item.tablet_offset_top}`
						}
						if ( item.tablet_offset_top_custom ) {
							customStyles += `.breakpoint-medium #${sectionHtmlId} {margin-top: ${item.tablet_offset_top_custom}px}`
						}
						if ( item.mobile_offset_top ) {
							className += ` -mobile-offset-top-${item.mobile_offset_top}`
						}
						if ( item.mobile_offset_top_custom ) {
							customStyles += `.breakpoint-small #${sectionHtmlId} {margin-top: ${item.mobile_offset_top_custom}px}`
						}

						// Offset bottom:
						if ( item.offset_bottom ) {
							className += ` -offset-bottom-${item.offset_bottom}`
						}
						if ( item.desktop_offset_bottom ) {
							className += ` -desktop-offset-bottom-${item.desktop_offset_bottom}`
						}
						if ( item.desktop_offset_bottom_custom ) {
							customStyles += `.breakpoint-large-min #${sectionHtmlId} {margin-bottom: ${item.desktop_offset_bottom_custom}px}`
						}
						if ( item.tablet_offset_bottom ) {
							className += ` -tablet-offset-bottom-${item.tablet_offset_bottom}`
						}
						if ( item.tablet_offset_bottom_custom ) {
							customStyles += `.breakpoint-medium #${sectionHtmlId} {margin-bottom: ${item.tablet_offset_bottom_custom}px}`
						}
						if ( item.mobile_offset_bottom ) {
							className += ` -mobile-offset-bottom-${item.mobile_offset_bottom}`
						}
						if ( item.mobile_offset_bottom_custom ) {
							customStyles += `.breakpoint-small #${sectionHtmlId} {margin-bottom: ${item.mobile_offset_bottom_custom}px}`
						}

						return (
							<div id={ columnHtmlId } className={ className } style={ style } key={ key }>
								{ innerMarkup }
								{ tooltipMarkup }
							</div>
						)
					} ) }
				</div>

				{ customStyles &&
					<style dangerouslySetInnerHTML={ { __html: customStyles } } />
				}
			</div>
		)
	}
}

export default Columns



// WEBPACK FOOTER //
// ./components/PageSections/Columns.jsx